// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_mv-1";
export var rowFirst = "_mv-3";
export var rowLast = "_mv-5";
export var rowMiddle = "_mv-4";
export var ticketListScroll = "_mv-2";
export var ticketStack = "_mv-0";